import axios from 'axios';

export function getStatisticsUsers(from, until) {
    return axios({
        method: 'POST',
        url: '/api/v1/statistics/user',
        data: {
            from,
            until,
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/statistics/users.js